import Dispatcher from "events-dispatch";

/**
 * Обработка перетаскивания файлов
 * @class
 * @property {HTMLElement} container Контейнер для установки атрибутов
 * @property {HTMLElement} area Активная зона для перетаскивания
 * @property {Function} onLoad Обработчик загрузки файлов
 */
class DndHandler {
  /**
   * @constructor
   * @param {string} selector css-селектор активной зоны
   * @param {*} container контейнер для атрибутов
   * @param {*} onLoad обработчик загрузки файлов
   */
  constructor(selector, container) {
    new Dispatcher(this);
    this.container = container;
    if (this.container) this.area = container.querySelector(selector);
    if (this.area) new Dispatcher(this.area);

    this._init();
  }

  /**
   * Установка наблюдателей
   */
  _init() {
      if (!this.area) return;
      ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
          this.area.addEventListener(eventName, (e) => this._preventDefaults(e), false)
      });
      ['dragenter', 'dragover'].forEach(eventName => {
          this.area.addEventListener(eventName, () => this._onHover(), false);
      });
      this.area.addEventListener("dragleave", () => this._onLeave(), false);
      this.area.addEventListener("drop", (e) => this._onDrop(e), false);
  }

  /**
   * Остановка события
   * @param {Event} e 
   */
  _preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  /**
   * Файл над активной зоной
   */
  _onHover() {
    this.container.setAttribute(DndHandler.dropAttr, "hover");
  }

  /**
   * Файл покинул активную зону
   */
  _onLeave() {
    this.container.removeAttribute(DndHandler.dropAttr);
  };

  /**
   * Файл отпущен над активной зоной
   * Событие drop
   * @param {Event} e 
   */
  _onDrop(e) {
    this.container.setAttribute(DndHandler.dropAttr, "drop");
    
    let files = e.dataTransfer.files;

    this.trigger(DndHandler.loadEvent, { files: files });

    setTimeout(() => {
        this.container.removeAttribute(DndHandler.dropAttr);
    }, 400);
  };
}

/**
* атрибут контейнера при перетаскивании
* @static
*/
DndHandler.dropAttr = "data-drop";
DndHandler.loadEvent = "load";

export { DndHandler };